"use client";
import CMSPage from "@/components/CMSPage/CMSPage";

const PrivacyPolicyPage = () => {
    return (
        <CMSPage 
            apiEndpoint="/cms-pages1/Mg=="
            pageTitle="Privacy Policy"
            defaultDescription="Welcome to Hyrelancer. Your privacy is paramount to us. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you use our platform."
        />
    );
};

export default PrivacyPolicyPage;